export default __webpack_public_path__ + "static/media/ContentLibraryDarkActive.9217aab4.svg";